module.exports = __webpack_public_path__ + "img/SX.8db7b1db.svg";